<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="getTitle">
        <v-card-actions>
          <a v-if="!isStaff" @click="$router.back()">
            <v-btn elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          </a>
          <a v-if="isStaff" @click="$router.back()">
            <v-btn elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          </a>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="saveUser">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  First Name
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" required placeholder="First name" pattern="[a-zA-Z\s]+"
                  title="Enter valid character" v-model.trim="userObj.firstName" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Last Name
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" required placeholder="Last name" pattern="[a-zA-Z\s]+"
                  title="Enter valid character" v-model.trim="userObj.lastName" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Email address
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" required placeholder="Email" autocomplete="new-email" type="email"
                  v-model="userObj.email" maxlength="100" title="Enter Valid Email id"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Date of Birth
                  <span class="requir error--text">*</span>
                </label>
                <custom-date-picker required placeholder="Date of Birth" v-model="userObj.dob" />
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Date of Joining
                  <span class="requir error--text">*</span>
                </label>
                <custom-date-picker required placeholder="Date of Joining" v-model="userObj.doj" maxlength="100" />
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Gender
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete class="my-0 py-1" :items="items" item-value="value" item-text="text"
                  placeholder="--Select_Gender--" v-model="userObj.gender" required> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Aadhar card Number
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" onKeyPress="if(this.value.length==12) return false;"
                  pattern="^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$" required placeholder="Aadhar Number"
                  v-model="userObj.aadharNumber" minlength="12" maxlength="12"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Pan card Number
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}" required placeholder="PAN number"
                  v-model.trim="userObj.panNumber" minlength="10" maxlength="10"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Address
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field required placeholder="Address" title="Enter valid character" class="my-0 py-1"
                  v-model.trim="userObj.address" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Country
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete class="my-0 py-1" :items="country" placeholder="--Select--" v-model="userObj.country"
                  item-value="value" item-text="text"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  State
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="userObj.state" required
                  item-value="name" :items="stateList" key="name" item-text="name"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  City
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" required placeholder="City" pattern="[a-zA-Z\s]+"
                  title="Enter valid character" v-model.trim="userObj.city" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Pincode
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" required placeholder="Pincode"
                  pattern="^[1-9]{1}[0-9]{2}\\s{0, 1}[0-9]{3}$" v-model="userObj.pincode"
                  onKeyPress="if(this.value.length==6) return false;" minlength="6"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="!isStaff">
                <label class="font-weight-medium body-2">
                  Email address
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" :readonly="emailFlag" autocomplete="new-email" required
                  v-model="userObj.email" maxlength="100" title="Enter Valid Email id"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="!isStaff">
                <label class="font-weight-medium body-2">
                  Password
                  <span v-if="!requiredFlag" class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" v-if="!requiredFlag" placeholder="********" autocomplete="new-password"
                  :type="show ? 'text' : 'password'" v-model="userObj.password" maxlength="20" password-reveal :error-messages="passwordErrorMsg"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"  @click:append="show = !show"></v-text-field>
                <v-text-field class="my-0 py-1" v-if="requiredFlag" placeholder="********" autocomplete="new-password"
                  :type="show ? 'text' : 'password'" v-model="userObj.password" maxlength="20" password-reveal :error-messages="passwordErrorMsg"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"  @click:append="show = !show"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="!isStaff">
                <label class="font-weight-medium body-2">
                  Concept
                </label>
                <v-text-field class="my-0 py-1" placeholder="FOFO/COCO" pattern="[a-zA-Z\s]+"
                  title="Enter valid character" v-model="userObj.concept" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="!isStaff">
                <label class="font-weight-medium body-2">
                  Roles
                  <span class="requir error--text">*</span>
                </label>
                <multiselect class="overflowmultiselect2" label="role" track-by="role"
                  @input="checkTicketAdmin(selectedRoles)" :close-on-select="false" :clear-on-select="false"
                  :preserve-search="true" :preselect-first="false" :multiple="true" :options="roles"
                  v-model="selectedRoles"><template slot="selection" slot-scope="{ values, isOpen }"><span
                      class="multiselect__single" v-if="values.role && !isOpen">{{ values.role }} </span></template>
                </multiselect>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Staff is Teacher?
                  <span class="requir error--text">*</span>
                </label>
                <v-radio-group v-if="isStaff" @change="teachingStaff()" v-model="userObj.isTeachingStaff" mandatory row>
                  <v-radio label="Yes" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" v-if="isStaff">
                <label class="font-weight-medium body-2">
                  Select Staff
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete placeholder="Select Staff" class="my-0 py-1" v-model="userObj.staffType" required
                  item-value="value" @change="getDesignations()" :items="staff" key="text" item-text="text">
                </v-autocomplete>
              </v-col>
              <v-col v-if="isStaff" cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Staff Designation
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete @change="setStaffDesignation" placeholder="Staff Designation" auto-select-first
                  class="my-0 py-1" v-model="userObj.designationID" required item-value="id" :items="designtns" key="id"
                  selected item-text="name"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Mobile Number
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" type="number" pattern="^[6-9]\d{9}$"
                  onKeyPress="if(this.value.length==10) return false;"
                  placeholder="Mobile number 10 digit"
                  :class="{ 'no-spinner': true, 'mobile-field': true }"
                  v-model="userObj.mobile"
                  @input="verifyInputMobile(userObj.mobile)"
                  >
                    <template v-slot:append>
                        <v-btn
                        v-if="isStaff && isBusAttendant && !isMobileNoVerified && userObj?.mobile?.length === 10"
                          icon
                          class="ml-2 verify-cta"
                          color="primary"
                          style="margin-right: 60px;"
                          x-small
                          @click="verifyOtp('user','up')"
                        >
                          verify Mobile No
                        </v-btn>
                        <v-icon color="#00ff00" v-if="isStaff && isBusAttendant && isMobileNoVerified && userObj.mobile.length === 10">mdi-check-decagram-outline</v-icon>
                      </template>
                </v-text-field>
              </v-col>
              <v-dialog v-model="numberChangeDialog" width="auto">
                <v-card prepend-icon="mdi-update" max-width="400">
                  <v-card-title>
                    <span class="headline"></span>
                  </v-card-title>
                  <v-card-subtitle>
                    Editing Mobile No. will require OTP Verification
                  </v-card-subtitle>
                  <v-card-actions>
                    <v-btn class="ms-auto" text @click="numberChangeDialog = false">Ok</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="showVerification" max-width="350" >
                  <v-card >
                    <!-- below may need to be removed -->
                    <div class="btn" style="position: relative; text-align: right;padding: 5px;"><v-btn class="btn closebtn" @click="showVerification = false" color="red" small><v-icon >mdi-close</v-icon></v-btn></div>
                    <v-card-title>
                      <h3 class="text-h6">Mobile phone verification</h3>
                    </v-card-title>
                    <v-card-subtitle>
                      <div class="text-body-2 font-weight-light">
                        Enter the code we just sent to your mobile phone
                        <span class="font-weight-black text-primary">{{ userObj.mobile }}</span>
                      </div>
                    </v-card-subtitle>
                    <v-card-actions style="display: inline-flex; flex-direction: column;">
                      <v-otp-input
                        v-model="otp"
                        class="mt-3"
                        length="4"
                        type="number"
                        placeholder="0"
                        variant="underlined"
                      ></v-otp-input>
                      <v-divider class="mt-3 mb-6"></v-divider>
                      <div v-if="isTimerEnded" class="mb-3 text-body-2">
                        Didn't get <strong>OTP</strong>?
                        <a href="#" @click.prevent="verifyOtp('userResend')">Resend</a>
                      </div>
                      <div v-else-if="this.timer===60" class="mb-3 text-body-2">Resend OTP in 01:00 </div>
                      <div v-else-if="this.timer>=10" class="mb-3 text-body-2">Resend OTP in 00:{{ timer }} </div>
                      <div v-else class="mb-3 text-body-2">Resend OTP in 00:0{{ timer }} </div>
                      <v-btn
                        class="my-4"
                        color="green"
                        height="40"
                        variant="flat"
                        width="70%"
                        :disabled="otp.length !== 4"
                        @click="verifyOtp('user')"
                      >Verify</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Franchisee (Selected : {{ selectedFranchisee.length ? selectedFranchisee.length : '0' }})
                  <span class="requir error--text">*</span>
                </label>
                <v-row no-gutters>
                  <v-col cols="12" md="4" lg="4" sm="6" xs="12">
                    <v-checkbox v-model="flag" @change="allFranchisee" label="All Franchisee"></v-checkbox>
                  </v-col>
                  <v-col v-if="checkAccessToAllClassFlag" cols="12" md="4" lg="4" sm="6" xs="12">
                    <v-checkbox v-model="isAccessToAllClass" label="All Classes"></v-checkbox>
                  </v-col>
                </v-row>
                <multiselect class="overflowmultiselect2" label="companyName" track-by="companyName"
                  :close-on-select="false" :clear-on-select="false" :preserve-search="true" :preselect-first="false"
                  :multiple="true" :options="franchiseeArr" v-model="selectedFranchisee" @remove="removeCheckFranchisee">
                  <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                      v-if="values.role && !isOpen">{{ values.companyName }} </span></template>
                </multiselect>
              </v-col>

              <v-col cols="12" md="6" v-if="!isStaff">
                <label class="font-weight-medium body-2"> Department <span class="requir error--text">*</span> </label>
                <v-select :items="departmentData" placeholder="Select department" v-model="userObj.department" dense
                  outlined></v-select>
              </v-col>
              <v-col class="col-md-4 col-12" v-if="isStaff &&  !isBusAttendant">
                <div class="font-weight-medium body-2">
                  <label class="font-weight-medium body-2">
                    Upload Resume
                    <span class="requir error--text">*</span>
                  </label>
                  <div class="control">
                    <template>
                      <b-field>
                        <b-upload v-model="userObj.resume" :required="!staffId" single drag-drop>
                          <section class="section">
                            <div class="content has-text-centered">
                              <p>
                                <b-icon icon="upload" size="is-large"> </b-icon>
                              </p>
                              <p class="has-text-primary">Upload or Drag-Drop only single file</p>
                            </div>
                          </section>
                        </b-upload>
                      </b-field>
                      <!-- <span class="error--text">File Size Should be less than 5MB</span> -->
                      <div class="tags" v-if="userObj.resume && userObj.resume.name">
                        <span class="tag is-primary">
                          {{ userObj.resume.name }}
                        </span>
                        <button class="delete is-small" type="button" @click="deleteDropFile(allowedDocumentType[0])"></button>
                      </div>
                    </template>
                  </div>
                </div>
              </v-col>
              <v-col class="col-md-4 col-12" v-if="isStaff && modules.uploadCodeOfConduct" >
                <div class="font-weight-medium body-2">
                  <label class="font-weight-medium body-2">
                    Code of Conduct
                    <span class="requir error--text">*</span>
                  </label>
                  <div class="control">
                    <template>
                      <b-field>
                        <b-upload v-model="userObj.codeOfConduct" :required="!staffId" single drag-drop :key="uploadKey"  @change="handleFileUpload">
                          <section class="section">
                            <div class="content has-text-centered">
                              <p>
                                <b-icon icon="upload" size="is-large"> </b-icon>
                              </p>
                              <p class="has-text-primary">Upload or Drag-Drop only single file</p>
                            </div>
                          </section>
                        </b-upload>
                      </b-field>
                      <div class="tags" v-if="userObj.codeOfConduct && userObj.codeOfConduct.name">
                        <span class="tag is-primary">
                          {{ userObj.codeOfConduct.name }}
                        </span>
                        <button class="delete is-small" type="button" @click="deleteCodeOfConduct(0)"></button>
                      </div>
                    </template>
                  </div>
                </div>
              </v-col>
              <v-row class="match-height match-heightwidth100 mx-1"
                  v-if="isStaff && isBusAttendant"
                  align-content-md = 'center'>
                  <v-col v-for="(document,index) in previousDocumentFiles" :key="index" cols="12" md="4">
                     <div class="font-weight-medium body-2 "
                        >
                      <!-- <label class="font-weight-medium body-2">
                        Last Uploaded {{ document.field.replace(/([A-Z])/g, ' $1') }}

                      </label> -->

                      <div class="control ">
                        <v-card  class="mb-2 d-flex flex-column align-center custompadd" tile="">
                          <v-toolbar flat>
                            <v-card-title class="lastuploadedpadd"> Last Uploaded {{ document.field.replace(/([A-Z])/g, ' $1') }} </v-card-title>
                            <v-spacer></v-spacer>
                            <v-btn icon small @click="deleteUploadedDocument(document,index)">
                                      <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </v-toolbar>
                          <div class="custompaddheight">
                             <v-img :src="document.urlPath"  ></v-img>
                          </div>
                        </v-card>
                      </div>
                     </div>
                  </v-col>

                  <v-col v-if="shouldShowUploader('busAttendentPhoto')" cols="12" md="4">
                  <div class="font-weight-medium body-2">
                    <label class="font-weight-medium body-2 mb-2">Upload Bus Attendant Photo <span class="requir error--text">*</span></label>
                    <div class="control controlcommonview">
                      <b-field>
                        <b-upload v-model="userObj.busAttendentPhoto" :required="!staffId" single drag-drop @input="onFileChange($event, allowedDocumentType[1])">
                          <section class="section">
                            <div class="content has-text-centered">
                              <p><b-icon icon="upload" size="is-large"></b-icon></p>
                              <p class="has-text-primary">Upload or Drag-Drop only single file</p>
                            </div>
                          </section>
                        </b-upload>
                      </b-field>
                      <span v-if="isValidDocument" class="boxvalidationtext">Please ensure to upload a full-face photo, 2 MB size. Allowed file types: jpg, jpeg, png, heic, heif.</span>
                      <div class="tags" v-if="userObj.busAttendentPhoto && userObj.busAttendentPhoto.name">
                        <span class="tag is-primary">{{ userObj.busAttendentPhoto.name }}</span>
                        <button class="delete is-small" type="button" @click="deleteDropFile(allowedDocumentType[1])"></button>
                      </div>
                    </div>
                  </div>
                  </v-col>

                  <v-col v-if="shouldShowUploader('aadharCardFrontPhoto')" cols="12" md="4">
                  <div class="font-weight-medium body-2">
                    <label class="font-weight-medium body-2 mb-2">Aadhar Card Front <span class="requir error--text">*</span></label>
                    <div class="control controlcommonview">
                      <b-field>
                        <b-upload v-model="userObj.aadharcardfront" :required="!staffId" single drag-drop @input="onFileChange($event, allowedDocumentType[2])">
                          <section class="section">
                            <div class="content has-text-centered">
                              <p><b-icon icon="upload" size="is-large"></b-icon></p>
                              <p class="has-text-primary">Upload or Drag-Drop only single file</p>
                            </div>
                          </section>
                        </b-upload>
                      </b-field>
                      <span class="boxvalidationtext">2 MB size. Allowed file types: jpg, jpeg, png, heic, heif.</span>
                      <div class="tags" v-if="userObj.aadharcardfront && userObj.aadharcardfront.name">
                        <span class="tag is-primary">{{ userObj.aadharcardfront.name }}</span>
                        <button class="delete is-small" type="button" @click="deleteDropFile(allowedDocumentType[2])"></button>
                      </div>
                    </div>
                  </div>
                  </v-col>

                  <v-col v-if="shouldShowUploader('aadharCardBackPhoto')" cols="12" md="4">
                  <div class="font-weight-medium body-2">
                    <label class="font-weight-medium body-2">Aadhar Card Back <span class="requir error--text">*</span></label>
                    <div class="control controlcommonview">
                      <b-field>
                        <b-upload v-model="userObj.aadharcardback" :required="!staffId" single drag-drop @input="onFileChange($event, allowedDocumentType[3])">
                          <section class="section">
                            <div class="content has-text-centered">
                              <p><b-icon icon="upload" size="is-large"></b-icon></p>
                              <p class="has-text-primary">Upload or Drag-Drop only single file</p>
                            </div>
                          </section>
                        </b-upload>
                      </b-field>
                      <span class="boxvalidationtext">2 MB size. Allowed file types: jpg, jpeg, png, heic, heif.</span>
                      <div class="tags" v-if="userObj.aadharcardback && userObj.aadharcardback.name">
                        <span class="tag is-primary">{{ userObj.aadharcardback.name }}</span>
                        <button class="delete is-small" type="button" @click="deleteDropFile(allowedDocumentType[3])"></button>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col v-if="shouldShowUploader('policeVerificationPhoto')" cols="12" md="4">
                  <div class="font-weight-medium body-2">
                    <label class="font-weight-medium body-2 mb-2">Police Verification <span class="requir error--text">*</span></label>
                    <div class="control controlcommonview">
                      <b-field>
                        <b-upload v-model="userObj.policeVerificationPhoto" :required="!staffId" single drag-drop @input="onFileChange($event, allowedDocumentType[4])">
                          <section class="section">
                            <div class="content has-text-centered">
                              <p><b-icon icon="upload" size="is-large"></b-icon></p>
                              <p class="has-text-primary">Upload or Drag-Drop only single file</p>
                            </div>
                          </section>
                        </b-upload>
                      </b-field>
                      <span class="boxvalidationtext">2 MB size. Allowed file types: jpg, jpeg, png, heic, heif.</span>
                      <div class="tags" v-if="userObj.policeVerificationPhoto && userObj.policeVerificationPhoto.name">
                        <span class="tag is-primary">{{ userObj.policeVerificationPhoto.name }}</span>
                        <button class="delete is-small" type="button" @click="deleteDropFile(allowedDocumentType[4])"></button>
                      </div>
                    </div>
                  </div>
                  </v-col>
              </v-row>

              <v-col cols="12" v-if="isStaff">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" :disabled="!validateSaveUser()" color="primary" type="submit" >
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" v-if="!isStaff">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card flat class="px-2"
        v-if="staffId"
        >
          <v-data-table
          :headers="headers"
          :items="logDetails"

        >
          <template v-slot:item="{ item }">
            <tr>
              <!-- <td>{{ index + 1 }}</td>
              <td>{{ item.updatedAt.split('T')[0] }}</td>
              <td> last role</td>
              <td>new role</td>
              <td>{{ item.createdBy }}</td> -->

               <td>{{ item.srNo }}</td>
              <td>{{ item.updatedDate }}</td>
              <td>{{ `${item.lastRoleDetails.lastRole} ${item.lastRoleDetails.startDate} - ${item.lastRoleDetails.endDate}` }}</td>
              <td>{{ item.newRole }}</td>
              <td>{{ item.updatedBy }}</td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import stores from '@/stores'
import CustomDatePicker from '../template/CustomDatePicker.vue'
import Utils from '@/utils'

const _ = require('lodash')

export default {
  name: 'SaveUser',
  components: {
    Multiselect,
    MaterialCard,
    CustomDatePicker
  },
  props: ['adminUserID', 'title', 'staffId'],
  data () {
    return {
      ownerNumberForVerification: null,
      isEditing: false,
      numberChangeDialog: false,
      isMobileNoVerified: false,
      verifiedFlag: false,
      referenceId: '',
      isTimerEnded: false,
      timer: 60,
      otp: '',
      showVerification: false,
      assignee: [],
      stateList: [],
      selectedAssignee: [],
      selectedFranchisee: [],
      selectedRoles: [],
      queryRelatedToInfo: [],
      checkFlagTicketAdmin: false,
      requiredFlag: false,
      flag: '',
      flag1: '',
      isLoading: false,
      getTitle: 'Add User',
      franchiseeArr: [],
      franchiseeCount: 0,
      designtns: [],
      roles: [],
      roleId: [],
      levelID: '',
      response1: [],
      country: [{ text: 'India', value: 'India' }],
      loginCategory: this.$route.name,
      isStaff: false,
      loadingComponent: null,
      emailFlag: false,
      completePostflag: false,
      userIdAfterPost: '',
      createUserFlag: false,
      staff: [],
      items: [
        { text: 'Female', value: 'Female' },
        { text: 'Male', value: 'Male' }
      ],
      headers: [
        { text: 'S.No', value: 'srNo' },
        { text: 'Updated Date', value: 'updatedDate' },
        { text: 'Last Role', value: 'lastRole' },
        { text: 'New Role', value: 'newRole' },
        { text: 'Updated By', value: 'updatedBy', align: 'center' }
      ],
      logDetails: [],
      allowedDocumentType: ['resume', 'image', 'aadharfront', 'aadharback', 'policeVerificationPhoto'],
      allowedExtensions: ['image/jpg', 'image/jpeg', 'image/png', 'image/heic', 'image/heif'],
      previousDocumentFiles: [],
      isValidDocument: true,
      maxFileSize: 1024 * 1024 * 2,
      userId: '',
      userObj: {
        firstName: '',
        lastName: '',
        email: '',
        designationID: '',
        password: '',
        franchisee: '',
        concept: '',
        queryRealtedTo: '',
        mobile: '',
        dob: '',
        doj: '',
        gender: '',
        aadharNumber: '',
        panNumber: '',
        address: '',
        country: 'India',
        state: '',
        city: '',
        pincode: '',
        isTeachingStaff: false,
        staffType: '',
        resume: null,
        department: '',
        codeOfConduct: null,
        busAttendentPhoto: null,
        aadharcardfront: null,
        aadharcardback: null,
        policeVerificationPhoto: null,
        documents: {
          aadharFront: null,
          aadharBack: null
        }
      },
      fromStaff: false,
      departmentData: constants.USER_DEPARTMENT,
      isAccessToAllFranchisee: false,
      isAccessToAllClass: false,
      checkAccessToAllClassFlag: false,
      allowedFormats: ['image/png', 'application/pdf', 'image/jpeg'],
      uploadKey: 0,
      dropFiles: null,
      modules: {
        uploadCodeOfConduct: this.checkModuleAccess('uploadCodeOfConduct')
      },
      passwordErrorMsg: '',
      show: false,
      isBusAttendant: false
    }
  },
  watch: {
    selectedRoles: function (newVal) {
      let checkTeacher = _.some(newVal, { role: 'TEACHER' })
      if (checkTeacher) {
        this.checkAccessToAllClassFlag = true
      } else {
        this.isAccessToAllClass = false
        this.checkAccessToAllClassFlag = false
      }
    },
    'userObj.mobile': function (newVal, oldVal) {
      this.referenceId = null
    }

  },
  async created () {
    if (this.loginCategory === 'Staff') {
      this.isStaff = true
      this.getTitle = 'Add Staff'
    } else {
      this.getTitle = 'Add User'
    }
    await this.getFranchiseeList()
    await this.getRoleList()
    if (stores.user.ACL.superAdmin) {
      await this.getQueryRelatedToInfo()
    }
    if (this.userObj.isTeachingStaff === true) {
      this.staff.push({ text: 'Teaching Staff', value: 'TEACHING_STAFF' }
      )
    } else {
      this.staff.push({ text: 'Non Teaching Staff', value: 'NON_TEACHING_STAFF' }, { text: 'Sub Staff', value: 'SUB_STAFF' })
    }
    if (this.staffId) {
      this.isStaff = true
      this.getTitle = 'Edit staff'
      await this.getStaffData(this.staffId)
      await this.getStaffUserLogsDetails()
    } else {
      if (this.adminUserID) {
        this.getTitle = 'Edit User'
        this.emailFlag = false
        await this.getUserDetails(this.adminUserID)
      } else {
        this.createUserFlag = true
      }
    }
    await this.checkTicketAdmin(this.selectedRoles)
    this.getState()
  },

  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    shouldShowUploader (field) {
      const documentExists = this.previousDocumentFiles.some(doc => doc.field === field)
      return !documentExists
    },
    deleteUploadedDocument (document, index) {
      this.previousDocumentFiles.splice(index, 1)
    },
    verifyInputMobile (number) {
      if (number === this.ownerNumberForVerification) {
        this.isMobileNoVerified = true
      } else {
        if (this.isMobileNoVerified && this.isStaff && this.isBusAttendant) {
          this.numberChangeDialog = true
        }
        this.isMobileNoVerified = false
      }
    },
    getRoleById () {

    },
    getStaffUserLogsDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vendors/${this.staffId}/logs`)

        data.map((item, index) => {
          // let oldRole = item.oldData && item.oldData.role ? this.getRoleById(item.oldData.role) : '-'
          // let newRole = item.newData && item.newData.role ? this.getRoleById(item.newData.role) : '-'
          this.logDetails.push({
            srNo: index + 1,
            updatedDate: moment(item.updatedAt).format('DD-MM-YYYY'),
            lastRoleDetails: {
              lastRole: item.oldData.role,
              startDate: moment(item.oldData.startDate).format('DD-MM-YYYY'),
              endDate: moment(item.oldData.endDate).format('DD-MM-YYYY')
            },
            newRole: item.newData.role,
            updatedBy: item.createdBy
          })
        })
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        // this.$router.push({ name: 'Vendor' })
      }
    },
    async verifyOtp (field, fieldData) {
      // User Mobile Verification
      if (field === 'user') {
        if (fieldData === 'up') {
          this.referenceId = ''
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
          }
          this.otp = ''
        }
        this.showVerification = true
        await this.verifyMobileNo(this.userObj.mobile)
        if (this.verifiedFlag) {
          this.isMobileNoVerified = true
          this.verifiedFlag = false
          this.showVerification = false
        }
      } else if (field === 'userResend') {
        await this.resendCode(this.userObj.mobile)
      }
    },
    async verifyMobileNo (mobileNo) {
      let apiResult = null
      if (!this.referenceId) {
        const payload = {
          'referenceId': null,
          'otpClient': null,
          'mobileNo': mobileNo,
          'resendCount': '0'
        }
        apiResult = await http.post(
          `${constants.API_URL}/api/admin/verifyotp`,
          payload
        )
        if (apiResult?.data?.isSent) {
          this.referenceId = apiResult.data.referenceId
        }
        this.timer = 60
        this.startTimer()
      } else {
        const payload = {
          'referenceId': this.referenceId,
          'otpClient': this.otp,
          'mobileNo': mobileNo,
          'resendCount': '0'
        }
        apiResult = await http.post(
          `${constants.API_URL}/api/admin/verifyotp`,
          payload
        )
        if (apiResult?.data?.isVerified) {
          this.verifiedFlag = true
          this.timer = 60
          this.referenceId = ''
          this.isTimerEnded = false
          this.otp = ''
          return this.$buefy.toast.open({
            message: 'Verified',
            type: 'is-success',
            duration: 3000
          })
        } else if (apiResult?.data?.isVerified === false) {
          return this.$buefy.toast.open({
            message: 'Wrong OTP. Try Again!',
            type: 'is-danger',
            duration: 3000
          })
        }
      }
    },
    startTimer () {
      this.interval = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(this.interval)
          this.isTimerEnded = true
        } else {
          this.timer--
        }
      }, 1000)
    },
    async resendCode (mobileNo) {
      this.otp = ''
      const payload = {
        'referenceId': this.referenceId,
        'otpClient': '',
        'mobileNo': mobileNo,
        'resendCount': '1'
      }
      const apiResult = await http.post(
        `${constants.API_URL}/api/admin/verifyotp`,
        payload
      )
      if (apiResult?.data?.isSent) {
        this.referenceId = apiResult.data.referenceId
      }
      this.timer = 60
      this.isTimerEnded = false
      this.startTimer()
    },
    validForm () {
      let isValid = true
      return isValid
    },
    onFileChange (file, key) {
      if (!this.allowedExtensions.includes(file.type)) {
        this.deleteDropFile(key)
        this.errMsg('Allowed file type will be jpg, jpeg, png, heic, heif')
      }
      if (file.size > this.maxFileSize) {
        this.deleteDropFile(key)
        this.errMsg(' Allowed Max 2 MB file size')
      }
    },
    teachingStaff: async function () {
      this.staff = []
      this.designtns = []
      this.checkAccessToAllClassFlag = false
      this.isAccessToAllClass = false
      this.userObj.staffType = ''
      this.userObj.designationID = ''
      if (this.userObj.isTeachingStaff === true) {
        this.staff.push({ text: 'Teaching Staff', value: 'TEACHING_STAFF' }
        )
      } else {
        this.staff.push({ text: 'Non Teaching Staff', value: 'NON_TEACHING_STAFF' }, { text: 'Sub Staff', value: 'SUB_STAFF' })
      }
    },
    setStaffDesignation: function () {
      if (this.userObj.designationID) {
        this.isAccessToAllClass = false
        let designationName = ''
        let designationType = null
        let designationObj = this.designtns.find(item => {
          return item.id === this.userObj.designationID
        })
        if (typeof designationObj === 'object' && Object.keys(designationObj).length > 0) {
          designationName = designationObj.name
          designationType = designationObj.staffType
        }
        if (designationName === 'Bus Attendant' && designationType === 'SUB_STAFF') {
          this.isBusAttendant = true
        } else {
          this.isBusAttendant = false
        }
        if (designationName === 'Teacher') {
          this.checkAccessToAllClassFlag = true
        } else {
          this.checkAccessToAllClassFlag = false
        }
      }
    },
    getDesignations: async function () {
      try {
        this.isLoading = true

        let res = await http.get(`${constants.API_URL}/api/staff/designation/${this.userObj.staffType}`)
        this.designtns = res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getStaffData: async function () {
      try {
        this.isEditing = true
        let response = await http.get(`${constants.API_URL}/api/staff/${this.staffId}`)
        await this.setUserDetails(response)
        let { dateOfJoining, dateOfBirth, gender, addharCard, panCard, address, country, state, city, pincode, mobileNo, staffType, isTeachingStaff, designationID, staffDesignation, codeOfConductUrl } = response.data.userStaff
        this.userObj.dob = moment(dateOfBirth)
          .utc()
          .format('YYYY-MM-DD')
        this.userObj.doj = moment(dateOfJoining, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.userObj.gender = gender === 'MALE' ? 'Male' : gender === 'FEMALE' ? 'Female' : gender
        this.userObj.aadharNumber = addharCard
        this.userObj.panNumber = panCard
        this.userObj.address = address
        this.userObj.country = country
        this.userObj.state = state
        this.userObj.city = city
        this.userObj.staffType = staffType
        this.userObj.isTeachingStaff = isTeachingStaff
        if (this.userObj.isTeachingStaff === true) {
          this.staff.push({ text: 'Teaching Staff', value: 'TEACHING_STAFF' }
          )
        } else {
          this.staff.push({ text: 'Non Teaching Staff', value: 'NON_TEACHING_STAFF' }, { text: 'Sub Staff', value: 'SUB_STAFF' })
        }
        if (response.data.documentFiles && response.data.documentFiles.length > 0) {
          this.previousDocumentFiles = response.data.documentFiles
        }
        this.userObj.pincode = pincode
        this.userObj.mobile = mobileNo
        this.userObj.designationID = designationID
        if (codeOfConductUrl) {
          const fileName = codeOfConductUrl.split('/').pop()
          const fileExtension = fileName.split('.').pop().toLowerCase()
          let fileType = ''
          switch (fileExtension) {
            case 'pdf':
              fileType = 'application/pdf'
              break
            case 'jpg':
            case 'jpeg':
              fileType = 'image/jpeg'
              break
            case 'png':
              fileType = 'image/png'
              break
            default:
              fileType = 'application/octet-stream' // Generic binary type
          }
          this.userObj.codeOfConduct = {
            name: fileName,
            url: codeOfConductUrl, // Optional, if you want to store the URL for other uses
            type: fileType
          }
        }
        // if (this.staffId && codeOfConductUrl) {
        //   filename = codeOfConductUrl.split('/').pop()
        //   console.log(filename)
        // }
        // this.userObj.codeOfConduct = filename

        if (this.userObj.mobile && this.isEditing && staffDesignation && staffDesignation.name === 'Bus Attendant') {
          this.ownerNumberForVerification = JSON.parse(JSON.stringify(this.userObj.mobile))
          this.isMobileNoVerified = true
        }
        await this.getDesignations()
        this.setStaffDesignation()
        this.isAccessToAllClass = response.data.isAccessToAllClasses
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getState: async function () {
      try {
        const stateresponse = await http.get(`${constants.API_URL}/api/states`)
        this.stateList = stateresponse.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    deleteDropFile (type) {
      if (type === 'resume') {
        delete this.userObj.resume.name
        this.userObj.resume = null
        // this.userObj.resume = [this.dropFiles]
        // this.userObj.resume.splice(0, 1)
      } else if (type === 'image') {
        delete this.userObj.busAttendentPhoto.name
        this.userObj.busAttendentPhoto = null
      } else if (type === 'aadharfront') {
        delete this.userObj.aadharcardfront.name
        this.userObj.aadharcardfront = null
      } else if (type === 'aadharback') {
        delete this.userObj.aadharcardback.name
        this.userObj.aadharcardback = null
      } else if (type === 'policeVerificationPhoto') {
        delete this.userObj.policeVerificationPhoto.name
        this.userObj.policeVerificationPhoto = null
      } else {
        this.userObj.busAttendentPhoto = null
        this.userObj.aadharcardfront = null
        this.userObj.aadharcardback = null
      }
    },
    deleteCodeOfConduct () {
      this.userObj.codeOfConduct = null

      this.dropFiles = null

      this.uploadKey += 1
    },

    handleFileUpload (newFile) {
      if (this.userObj.codeOfConduct) {
        this.userObj.codeOfConduct = null // Clear the previous file
      }

      this.userObj.codeOfConduct = newFile

      this.uploadKey = 0

      this.dropFiles = null

      this.uploadKey += 1
    },
    removeCheckFranchisee: function () {
      this.flag = false
      return true
    },
    removeCheckQuery: function () {
      this.flag1 = false
      return true
    },
    getQueryRelatedToInfo: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/ticket/meta`)
        let queryList = _.filter(response.data, item => {
          if (item && item.type === 'queryRelatedTo') {
            return item
          }
        })
        _.forEach(queryList, item => {
          let i = 1
          while (i <= 3) {
            item.level = i
            this.assignee.push({ name: item.name + '- level' + i, value: { queryRelatedToID: item.id, level: i } })

            i++
          }
          return this.assignee
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      } finally {
        this.isLoading = false
      }
    },
    checkTicketAdmin: function (a) {
      if (a && a.length > 0) {
        let result = _.some(a, { role: 'TICKET_ADMIN' })
        if (result) {
          this.checkFlagTicketAdmin = true
        } else {
          this.checkFlagTicketAdmin = false
        }

        let checkTeacher = _.some(a, { role: 'TEACHER' })
        if (checkTeacher) {
          this.checkAccessToAllClassFlag = true
        } else {
          this.checkAccessToAllClassFlag = false
        }
      } else {
        this.checkFlagTicketAdmin = false
      }
    },
    allFranchisee: function () {
      let franchiseeArray = []
      if (this.flag === true) {
        this.isAccessToAllFranchisee = true
        this.franchiseeArr.forEach(Obj => {
          franchiseeArray.push(Obj)
        })
        this.flag = true
      }
      this.selectedFranchisee = franchiseeArray
    },
    allQuery: function () {
      let queryArray = []
      if (this.flag1 === true) {
        this.assignee.forEach(obj => {
          queryArray.push(obj)
        })
        this.flag1 = true
      }

      this.selectedAssignee = _.uniqBy(queryArray, 'name')

      return this.selectedAssignee
    },
    getRoleList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/roles`)
        this.roles = data

        this.isLoading = false

        return this.roles
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true

        const response = await http.get(`${constants.API_URL}/api/franchisee/active`)
        let data = response.data
        this.franchiseeArr = data.rows
        this.franchiseeCount = data.count
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    validateSaveUser: function () {
      if (this.isStaff) {
        if (!this.userObj.designationID) {
          return false
        }
        if (moment(this.userObj.dob).format('YYYY').length !== 4) {
          return false
        } else if (moment(this.userObj.doj).format('YYYY').length !== 4) {
          return false
        }

        if (this.userObj.dob >= this.userObj.doj) {
          return false
        }

        // if (this.isBusAttendant && !this.userObj.busAttendentPhoto) {
        //   return false
        // }

        // if ((this.isBusAttendant && !this.staffId) && (!this.userObj.busAttendentPhoto && !this.userObj.aadharcardfront && !this.userObj.aadharcardback)) {
        //   return false
        // }
        // if ((this.isBusAttendant && this.staffId) && (!this.userObj.busAttendentPhoto && !this.userObj.aadharcardfront && !this.userObj.aadharcardback)) {
        //   return false
        // }
        if (this.isBusAttendant && !this.isStaff) {
          if (!this.userObj.busAttendentPhoto || !this.userObj.aadharcardfront || !this.userObj.aadharcardback || !this.userObj.policeVerificationPhoto) {
            return false
          }
        }
        if (this.isBusAttendant && this.isStaff) {
          const busAttendentExists = this.previousDocumentFiles.some(doc => doc.field === 'busAttendentPhoto')
          const adharFrontExists = this.previousDocumentFiles.some(doc => doc.field === 'aadharCardFrontPhoto')
          const adharBackExists = this.previousDocumentFiles.some(doc => doc.field === 'aadharCardBackPhoto')
          const policeVerificationExists = this.previousDocumentFiles.some(doc => doc.field === 'policeVerificationPhoto')

          if ((!busAttendentExists && !this.userObj.busAttendentPhoto) ||
              (!adharFrontExists && !this.userObj.aadharcardfront) ||
              (!adharBackExists && !this.userObj.aadharcardback) ||
              (!policeVerificationExists && !this.userObj.policeVerificationPhoto)) {
            return false
          }
        }
        if (this.isStaff && this.isBusAttendant && !this.isMobileNoVerified) {
          return false
        }
      }
      if (this.selectedFranchisee.length === 0) {
        return false
      }
      if (!this.userObj.mobile) {
        return false
      }
      if (this.userObj.mobile.length !== 10) {
        return false
      }
      return true
    },
    saveUser: async function () {
      if (!this.isStaff) {
        if (!this.adminUserID && !this.userObj.password) {
          this.errMsg('Kindly add password!!')
          return false
        }
        if (this.selectedRoles.length === 0) {
          this.errMsg("Kindly select Role's value!!")
          return false
        }
        if (!this.userObj.department) {
          return this.errMsg('Kindly select Department!!')
        }

        if (this.userObj.password.length > 0 && this.userObj.password.length < 8) {
          this.passwordErrorMsg = 'Password must be 8 digit long!!'
          return false
        }
        if (this.userObj.password.length > 0) {
          // At least 2 digits. At least 2 lowercase letters. At least 2 uppercase letters. At least 2 special characters (from ! @ # $ %).
          let pattern = /(?=(.*\d){2})(?=(.*[a-z]){2})(?=(.*[A-Z]){2})(?=(.*[!@#$%]){2})/
          if (!pattern.test(this.userObj.password)) {
            this.passwordErrorMsg = 'At least 2 digits. At least 2 lowercase letters. At least 2 uppercase letters. At least 2 special characters (! @ # $ %)'
            return false
          }
        }
        this.passwordErrorMsg = ''
        this.show = false
      }
      if (this.isStaff) {
        if (!this.userObj.designationID) {
          this.errMsg('Kindly select Designation!!')
          return false
        }
      }
      if (!this.userObj.mobile) {
        this.errMsg('Kindly add mobile number!!')
        return false
      }
      if (this.selectedFranchisee.length === 0) {
        this.errMsg('Kindly select Franchisee value!!')
        return false
      }
      const roleId = _.map(this.selectedRoles, 'id')

      const franchisee = _.map(this.selectedFranchisee, 'id')
      let selectAssignee = _.map(this.selectedAssignee, 'value')
      if (this.checkFlagTicketAdmin && !_.isEmpty(selectAssignee) && _.isEmpty(franchisee)) {
        this.errMsg('Select Franchisee')
        return false
      }
      try {
        this.isLoading = true

        const data = {
          firstName: this.userObj.firstName,
          lastName: this.userObj.lastName,
          email: this.userObj.email,
          mobile: this.userObj.mobile,
          roleId,
          password: this.userObj.password || '',
          franchisee,
          concept: this.userObj.concept || '',
          department: this.userObj.department || '',
          isAccessToAllFranchisee: this.isAccessToAllFranchisee,
          isAccessToAllClasses: this.isAccessToAllClass
        }
        if (this.isStaff) {
          if (!this.validateSaveUser()) {
            this.errMsg('Please Fill Mandatory Details')
            return
          }

          if (moment(this.userObj.dob).format('YYYY').length !== 4) {
            this.errMsg('Date of birth is not valid!')
            return false
          } else if (moment(this.userObj.doj).format('YYYY').length !== 4) {
            this.errMsg('Date of joining is not valid!')
            return false
          }

          if (this.userObj.dob >= this.userObj.doj) {
            this.errMsg('Date of Joining must be greater than Date of birth!')
            return false
          }

          if (this.userObj.codeOfConduct && this.userObj.codeOfConduct instanceof File) {
            const fileType = this.userObj.codeOfConduct.type
            const maxFileSize = 10 * 1024 * 1024 // 10 MB
            const file = this.userObj.codeOfConduct
            const fileSize = file.size

            if (!this.allowedFormats.includes(fileType)) {
              this.errMsg('Invalid file format. Please upload a PNG, PDF, or JPEG file.')
              return
            }

            if (fileSize > maxFileSize) {
              this.errMsg('File size too large. Please upload a file under 10MB.')
              return
            }
          }

          let formData = new FormData()
          formData.append('firstName', this.userObj.firstName)
          formData.append('lastName', this.userObj.lastName)
          formData.append('dateOfBirth', moment(this.userObj.dob).format())
          formData.append('gender', this.userObj.gender)
          formData.append('mobileNo', this.userObj.mobile)
          formData.append('addharCard', this.userObj.aadharNumber)
          formData.append('panCard', this.userObj.panNumber)
          formData.append('address', this.userObj.address)
          formData.append('country', this.userObj.country)
          formData.append('state', this.userObj.state)
          formData.append('city', this.userObj.city)
          formData.append('pincode', this.userObj.pincode)
          formData.append('designationID', this.userObj.designationID)
          formData.append('dateOfJoining', moment(this.userObj.doj).format('YYYY/MM/DD'))
          formData.append('staffType', this.userObj.staffType)
          formData.append('isTeachingStaff', this.userObj.isTeachingStaff)
          // formData.append('roleId', JSON.stringify(roleId))
          formData.append('franchisee', JSON.stringify(franchisee))
          formData.append('email', this.userObj.email)
          if (this.userObj.department) {
            formData.append('department', this.userObj.department)
          }
          if (this.isStaff && this.isBusAttendant && !this.isMobileNoVerified) {
            this.errMsg('Mobile No. should be verified!')
            return false
          }
          if (this.userObj.resume && this.userObj.resume.name) {
            formData.append('resumeDoc', this.userObj.resume)
          }
          // The instanceof File check ensures that only actual file objects are appended to FormData
          if (this.userObj.codeOfConduct && this.userObj.codeOfConduct instanceof File) {
            formData.append('codeOfConductDoc', this.userObj.codeOfConduct)
          }

          if (this.userObj.busAttendentPhoto && this.userObj.busAttendentPhoto.name) {
            formData.append('busAttendentImage', this.userObj.busAttendentPhoto)
          }
          if (this.userObj.aadharcardfront && this.userObj.aadharcardfront.name) {
            formData.append('aadharCardFrontImage', this.userObj.aadharcardfront)
          }
          if (this.userObj.aadharcardback && this.userObj.aadharcardback.name) {
            formData.append('aadharCardBackImage', this.userObj.aadharcardback)
          }
          if (this.userObj.policeVerificationPhoto && this.userObj.policeVerificationPhoto.name) {
            formData.append('policeVerificationImage', this.userObj.policeVerificationPhoto)
          }
          if (!this.staffId) {
            formData.append('isActive', true)
          }
          formData.append('isAccessToAllFranchisee', this.isAccessToAllFranchisee)
          formData.append('isAccessToAllClasses', this.isAccessToAllClass)
          if (this.staffId) {
            formData.append('userId', this.staffId)
            await http.post(`${constants.API_URL}/api/admin/user/staff/${this.staffId}`, formData)
            // this.$router.push({ name: 'staffList' })

            this.okMsg('Staff information updated successfully!')
          } else {
            await http.post(`${constants.API_URL}/api/admin/user/staff`, formData)
            this.okMsg('Staff added successfully!')
          }
        } else if (this.adminUserID) {
          await http.put(`${constants.API_URL}/api/admin/${this.adminUserID}`, data)
          this.userId = this.adminUserID
          this.okMsg('User information updated successfully!')
        } else {
          const res = await http.post(`${constants.API_URL}/api/admin`, data)
          this.completePostflag = true
          this.userIdAfterPost = res.data.id
          this.okMsg('User information added successfully!')
        }
        if (!this.isStaff && !this.staffId) {
          if (this.createUserFlag && !this.checkFlagTicketAdmin) {
            this.$router.push({ name: 'User', params: { current: 1 } })
          }
        }
        if (this.isStaff) {
          this.$router.push({ name: 'staffList' })
        } else {
          this.$router.push({ name: 'User', params: { current: 1 } })
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getUserDetails: async function (adminUserID) {
      try {
        this.requiredFlag = true
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/admin/${adminUserID}`)
        await this.setUserDetails(response)
        return this.userObj
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg('Error While fetching User', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    setUserDetails: async function (response) {
      this.isAccessToAllClass = false
      let data = response.data
      this.userObj = data
      this.userObj.password = ''
      this.selectedRoles = []
      this.selectedRoles = _.map(data.userRoleMaps, 'role')
      this.selectedFranchisee = _.map(data.franchiseeUsersMaps, 'franchisee')
      this.isAccessToAllClass = (data.isAccessToAllClasses === true) ? data.isAccessToAllClasses : false
      this.selectedAssignee = []
      _.map(this.userObj.ticketAssignees, obj => {
        this.selectedAssignee.push({ name: obj.queryRelatedTo.name + '- level' + obj.level, value: { queryRelatedToID: obj.queryRelatedToID, level: obj.level } })
      })
      if (this.selectedFranchisee.length === this.franchiseeCount) {
        this.flag = true
      }
      await this.checkTicketAdmin(this.selectedRoles)
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
    // ,
    // getQueryDetails: function () {
    // let assignee = []

    // _.map(this.userObj.ticketAssignees, obj => {
    // assignee.push({ name: obj.queryRelatedTo.name + '- level' + obj.level, value: { queryRelatedToID: obj.queryRelatedToID, level: obj.level } })
    // })

    // return assignee
    // }
  }
}
</script>
<style>
.no-spinner input::-webkit-outer-spin-button,
.no-spinner input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.no-spinner input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
.mobile-field {
  position: relative
}
.verify-cta {
  position: absolute;
  right: 0
}
.match-height{
  display: flex;
    flex-wrap: wrap;
}
.match-height>[class*=col] {
    display: flex;
    flex-flow: column;
}
.custompadd{
  padding:15px;
}
.custompaddheight{
  height:300px;
  }
.mobile-field {
  position: relative
}
.verify-cta {
  position: absolute;
  right: 0
}
.lastuploadedpadd{
  padding-left: 0px;
    padding-right: 0px;
    font-size: 16px;
}
.custompaddheight{
  height:300px;
}
.custompaddheight img{
  max-width:100%;
}
.custompaddheight{
  width:100%;
  overflow: hidden;
}
.custompaddheight .v-image__image.v-image__image--cover{
  /* height: 50%; */
  background-size: contain;
}
.custompaddheight .v-responsive__sizer{
  padding-bottom: 100%;
}
.custompaddheight .v-image.v-responsive{
  height: 100%;
}
.custompadd .v-sheet.theme--light{
  width: 100%;
}
.boxvalidationtext{
  font-size: 13px;
}
.controlcommonview{
  width: 100%;
}
.controlcommonview .upload-draggable.is-primary{
    display: block;
    width: 100%;
}
.controlcommonview .upload.control{
  width: 100%;
}
.match-heightwidth100{
  width:100%;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
